import { Mail, Bell } from 'lucide-react';

export default function Email() {
  return (
    <div className="min-h-screen bg-[#08080c] flex flex-col items-center justify-center p-6 pb-20" data-testid="email-screen">
      <div className="text-center max-w-sm">
        {/* Icon */}
        <div className="w-20 h-20 mx-auto mb-6 border border-[#00d4ff]/30 rounded-2xl flex items-center justify-center bg-[#00d4ff]/5">
          <Mail 
            className="w-10 h-10 text-[#00d4ff]" 
            style={{ filter: 'drop-shadow(0 0 8px rgba(0, 212, 255, 0.5))' }}
          />
        </div>
        
        {/* Title */}
        <h1 className="font-mono text-xl text-[#00d4ff] mb-2">Email</h1>
        
        {/* Coming Soon Badge */}
        <div className="inline-flex items-center gap-2 px-4 py-2 bg-[#ffd700]/10 border border-[#ffd700]/30 rounded-full mb-6">
          <Bell className="w-4 h-4 text-[#ffd700]" />
          <span className="font-mono text-xs text-[#ffd700] uppercase tracking-wider">Coming Soon</span>
        </div>
        
        {/* Description */}
        <p className="text-sm text-[#7a7a9a] mb-6">
          Connect your email accounts and manage all your messages in one place. Send, receive, and organize emails directly from Sage.
        </p>
        
        {/* Features Preview */}
        <div className="space-y-3 text-left">
          <div className="bg-[#0d0d12] border border-[#1a1a24] p-3 rounded-lg">
            <p className="font-mono text-[10px] text-[#00d4ff] uppercase tracking-wider mb-1">Unified Inbox</p>
            <p className="text-xs text-[#4a4a60]">All your email accounts in one view</p>
          </div>
          <div className="bg-[#0d0d12] border border-[#1a1a24] p-3 rounded-lg">
            <p className="font-mono text-[10px] text-[#00d4ff] uppercase tracking-wider mb-1">Smart Compose</p>
            <p className="text-xs text-[#4a4a60]">AI-powered email drafting with Sage</p>
          </div>
          <div className="bg-[#0d0d12] border border-[#1a1a24] p-3 rounded-lg">
            <p className="font-mono text-[10px] text-[#00d4ff] uppercase tracking-wider mb-1">Quick Actions</p>
            <p className="text-xs text-[#4a4a60]">Reply, forward, and archive with ease</p>
          </div>
        </div>
      </div>
    </div>
  );
}
